import { Box, Button, Divider, IconButton, Tooltip } from "@mui/material"
import { Content } from "./Content"
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Smartphone, Computer} from '@mui/icons-material';
import { Details } from "./Details";
import { Design } from "./Design";
import { rqx } from "../../../../../../core/request/API";
import { env } from "../../../../../../core/Env";

export const Tabs = ({marketing_camp, __SESSION }) => {
    const { form, job, required } = marketing_camp
    const urlParams = new URLSearchParams(window.location.search)
    const history = useHistory()

    const handlerTabs = (step) => {
        history.push(`?id=3&step=${step}`)
    }

    const handlerChange = async(e) => {
        const { name, value, checked, files } = e.target
        let val;
        if (name === 'with_job_acc' || name === 'violator') {
            val = checked
            if (name === 'with_job_acc') {
                if (checked) {
                    const r = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_vacancy`, {company_id: __SESSION.data.uaccess[0].company_id })
                    job.set({...job.data, list : r})
                    form.set({...form.data, job_vacancy : '', with_job_acc : true,})
                    return
                }else{
                    form.set({...form.data, job_vacancy : '', with_job_acc : false,
                        qualification:  
                            [
                                {value: "Integrate applocations with REST APIS", stat: false, msg: ''}, 
                                {value: "Knowledge of GIT/Bucket", stat: false, msg: ''},
                                {value: "Strong problem-solving", stat: false, msg: ''},
                                {value: "Develop and maintain mobile application Integrate applocations with REST APIS", stat: false, msg: ''},
                                {value: "Knowledge of GIT/Bucket", stat: false, msg: ''},
                                {value: "Strong problem-solving", stat: false, msg: ''},
                                {value: "Develop and maintain mobile application", stat: false, msg: ''},
                            ]   
                    })
                    return
                }
            }
        }else if(name === 'company_logo' || name === 'ft_image' || name === 'bg_image' || name === 'violator_image'){
            const upld_file = files[0]
            val = {value: upld_file, object: URL.createObjectURL(upld_file), name: upld_file.name, size: upld_file.size, type: upld_file.type.split('/')[1], stat: false, msg: '', }
        }else {
            val = value
            if (form.data.with_job_acc && name === 'job_vacancy') {
                const q = await rqx.get(`<<tool>>/${env()}/marketing_campaign/job_qualification`, {job_id: value })
                const updateQ = q.map(item => ({
                    ...item, stat : false, msg: ''
                }))
                job.set({...job.data, qualification : updateQ})
            }
        }
        form.set({...form.data, [name] : val})
    }

    const validateTabsHasRequired = (type) => {
        if (type === 'content') {
            const hasAny = ["company_logo", "tagline", "work_location", "job_vacancy", "qualification", ].some(val => required.data.includes(val));
            return hasAny
        }
        if (type === 'details') {
            const hasAny = ["poster_name"].some(val => required.data.includes(val));
            return hasAny
        }
    }
    
    return (
        <Box display="flex" flexDirection="column"  height="100%" className="overflowY">
            <Box display="flex" justifyContent="space-around" p="16px" >
                <Box component={Button} variant="outlined" width={80} onClick={() => handlerTabs('content')}
                    bgcolor={urlParams.get('step') === 'content' ? "#009F4D" : "#fff"} color={urlParams.get('step') === 'content' ? "#fff" : "#000"}
                    sx={{':hover': {bgcolor: urlParams.get('step') === 'content' ? "#009F4D" : "#fff" } }}
                    borderColor={validateTabsHasRequired('content') ? "red" : "#009F4D"}
                >
                    Content
                </Box>
                <Box component={Button} variant="outlined" width={80} onClick={() => handlerTabs('design')}
                    bgcolor={urlParams.get('step') === 'design' ? "#009F4D" : "#fff"} color={urlParams.get('step') === 'design' ? "#fff" : "#000"}
                    sx={{':hover': {bgcolor: urlParams.get('step') === 'design' ? "#009F4D" : "#fff" } }}
                >
                    Design
                </Box>
                <Box component={Button} variant="outlined" width={80} onClick={() => handlerTabs('details')}
                    bgcolor={urlParams.get('step') === 'details' ? "#009F4D" : "#fff"} color={urlParams.get('step') === 'details' ? "#fff" : "#000"}
                    sx={{':hover': {bgcolor: urlParams.get('step') === 'details' ? "#009F4D" : "#fff" } }}
                    borderColor={validateTabsHasRequired('details') ? "red" : "#009F4D"}
                >
                    Details
                </Box>
            </Box>
            <Divider />
            <Box display="flex" flexDirection="column" p="16px" boxShadow="0px 0px 4px rgba(0, 0, 0, 0.12)" height="100%" className="overflowY">
                {
                    urlParams.get('step') === 'content' ?
                        <Content handlerChange={handlerChange} marketing_camp={marketing_camp} />
                    : 
                        urlParams.get('step') === 'design' ?
                            <Design handlerChange={handlerChange} marketing_camp={marketing_camp} />
                        :
                            urlParams.get('step') === 'details' ?
                                <Details handlerChange={handlerChange} form={form} />
                            :
                                <Box> 
                                    404
                                </Box>
                }
            </Box>
            <Box p="16px" bgcolor="#ffffff" >
                <Box display="flex" gap="16px">
                    <IconButton sx={{border: '1px solid #1976d2', borderRadius: 1}}>
                        <Smartphone sx={{color: '#1976d2'}} />
                    </IconButton>
                    <Tooltip title="This is not available" arrow>
                        <IconButton>
                            <Computer />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        </Box>
    )
}
